import type { IResponse } from '@/features/api/extranet'
import type { DossierDTO } from '@/features/api/extranet/dto/Dossier/Synthese'
import type { LovDossierDTO } from '@/features/api/extranet/dto/Dossier/Synthese/LovDossierDTO'
import { ensureSuccessStatusCode, useFetch } from '@/features/fetch'

export async function loadDossier(code: string, init?: RequestInit): Promise<DossierDTO> {
  init = { ...{ sablier: true, dialogMode: 'retry' }, ...(init ?? {}) }

  const fetch = useFetch('extranet')
  const response = await fetch(`/dossiers/${code}`, init)
  ensureSuccessStatusCode(response)
  const result = (await response.json()) as IResponse<DossierDTO>

  return result.data
}

export async function loadDossierLov(init?: RequestInit): Promise<LovDossierDTO> {
  init = { ...{ sablier: true, dialogMode: 'retry', appCache: true }, ...(init ?? {}) }

  const fetch = useFetch('extranet')
  const response = await fetch(`/dossiers/lov`, init)
  ensureSuccessStatusCode(response)
  const result = (await response.json()) as IResponse<LovDossierDTO>

  return result.data
}

export async function loadDossierOutilFpe(code: string, init?: RequestInit): Promise<DossierDTO> {
  init = { ...{ sablier: true, dialogMode: 'retry' }, ...(init ?? {}) }
  const fetch = useFetch('extranet')
  const response = await fetch(`/outilsfpe/${code}`, init)
  ensureSuccessStatusCode(response)
  const result = (await response.json()) as IResponse<DossierDTO>

  return result.data
}

export async function loadDossierOutilFpeLov(init?: RequestInit): Promise<LovDossierDTO> {
  init = { ...{ sablier: true, dialogMode: 'retry', appCache: true }, ...(init ?? {}) }

  const fetch = useFetch('extranet')
  const response = await fetch(`/outilsfpe/lov`, init)
  ensureSuccessStatusCode(response)
  const result = (await response.json()) as IResponse<LovDossierDTO>

  return result.data
}
